/* ============================================================
   Opcao de Subscricao v2 (pa_custom)
   1. Selecao do painel (compra unica / plano)
   2. Injeta selling_plan e quantidade (unidades por entrega) no formulario
   3. Atualiza precos dos paineis na troca de variante
   4. Sincroniza o bloco de preco principal
   5. Expande / recolhe a timeline de ofertas
   ============================================================ */

(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function parseAllocations(panel) {
    try {
      return JSON.parse((panel.dataset.allocations || '{}').replace(/&quot;/g, '"'));
    } catch (e) {
      return {};
    }
  }

  function init(wrapper) {
    if (wrapper.dataset.so2Init) return;
    wrapper.dataset.so2Init = '1';

    var sectionId  = wrapper.dataset.sectionId;
    var defaultKey = wrapper.dataset.default;
    var panels     = Array.prototype.slice.call(wrapper.querySelectorAll('.pa-so2__panel'));
    var currentVariantId = null;
    var originalPriceHTML = null;

    // ── Formulario ───────────────────────────────────────────
    function getForm() { return document.getElementById('product-form-' + sectionId); }

    function setSellingPlan(planId) {
      var form = getForm();
      if (!form) return;
      var input = form.querySelector('input[name="selling_plan"]');
      if (planId) {
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          form.appendChild(input);
        }
        input.value = planId;
      } else if (input) {
        input.remove();
      }
    }

    function setQuantity(units) {
      var form = getForm();
      if (!form) return;
      var qty = form.querySelector('[name="quantity"]');
      if (!qty) {
        qty = document.createElement('input');
        qty.type = 'hidden';
        qty.name = 'quantity';
        qty.dataset.so2Qty = '1';
        form.appendChild(qty);
      }
      qty.value = String(units);
      if (!qty.dataset.so2Qty) {
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // ── Bloco de preco principal ─────────────────────────────
    function getPriceBlock() {
      return document.querySelector('[data-so-price-target="' + sectionId + '"]');
    }

    function updateMainPrice(panel) {
      var block = getPriceBlock();
      if (!block) return;
      var priceEl   = block.querySelector('.product-price--original');
      var compareEl = block.querySelector('.product-price--compare');
      if (!priceEl) return;

      var data = getPanelData(panel);

      if (panel.dataset.planId && data) {
        if (originalPriceHTML === null) {
          var pd = block.querySelector('.product-price');
          if (pd) originalPriceHTML = pd.innerHTML;
        }
        var hidden = priceEl.querySelector('.visually-hidden');
        if (hidden) {
          Array.prototype.slice.call(priceEl.childNodes).forEach(function (n) { if (n !== hidden) priceEl.removeChild(n); });
          priceEl.appendChild(document.createTextNode(formatMoney(data.first)));
        } else {
          priceEl.textContent = formatMoney(data.first);
        }
        if (!compareEl) {
          compareEl = document.createElement('del');
          compareEl.className = 'product-price--compare so2-injected-compare';
          priceEl.parentNode.insertBefore(compareEl, priceEl.nextSibling);
        }
        compareEl.innerHTML = '<span style="text-decoration:line-through;">' + formatMoney(data.price) + '</span>';
        compareEl.style.display = '';
      } else if (originalPriceHTML !== null) {
        var pd2 = block.querySelector('.product-price');
        if (pd2) pd2.innerHTML = originalPriceHTML;
      }
    }

    // ── Dados por painel ─────────────────────────────────────
    function getPanelData(panel) {
      if (!panel.dataset.planId) return null;
      var allocations = parseAllocations(panel);
      if (currentVariantId && allocations[String(currentVariantId)]) return allocations[String(currentVariantId)];
      var keys = Object.keys(allocations);
      return keys.length ? allocations[keys[0]] : null;
    }

    function getSelected() {
      return wrapper.querySelector('.pa-so2__panel.is-selected');
    }

    // ── Selecao ──────────────────────────────────────────────
    function select(key) {
      var target = null;
      panels.forEach(function (panel) {
        var on = panel.dataset.key === key;
        panel.classList.toggle('is-selected', on);
        if (panel.getAttribute('role') === 'radio') panel.setAttribute('aria-checked', on ? 'true' : 'false');
        if (on) target = panel;
      });
      if (!target) return;

      var planId = target.dataset.planId || null;
      setSellingPlan(planId);
      setQuantity(planId ? parseInt(target.dataset.units, 10) || 1 : 1);
      updateMainPrice(target);
    }

    // ── Troca de variante ────────────────────────────────────
    function updatePrices(variantId) {
      currentVariantId = variantId;
      panels.forEach(function (panel) {
        if (!panel.dataset.planId) {
          var ot = panel.querySelector('[data-price-onetime]');
          var anyPlan = panels.filter(function (p) { return p.dataset.planId; })[0];
          var base = anyPlan ? parseAllocations(anyPlan)[String(variantId)] : null;
          if (ot && base) ot.textContent = formatMoney(base.price);
          return;
        }
        var data = parseAllocations(panel)[String(variantId)];
        if (!data) return;
        var units = parseInt(panel.dataset.units, 10) || 1;
        var first = panel.querySelector('[data-price-first]');
        var orig  = panel.querySelector('[data-price-original]');
        var deliv = panel.querySelector('[data-price-delivery]');
        var badge = panel.querySelector('[data-discount-badge]');
        if (first) first.textContent = formatMoney(data.first);
        if (orig)  orig.textContent  = formatMoney(data.price);
        if (deliv) deliv.textContent = formatMoney(data.first * units);
        if (badge && data.price > 0) {
          var pct = Math.round((data.price - data.first) * 100 / data.price);
          badge.textContent = badge.textContent.replace(/\d+/, String(pct));
        }
      });
      originalPriceHTML = null;
      var sel = getSelected();
      if (sel) updateMainPrice(sel);
    }

    // ── Timeline ─────────────────────────────────────────────
    wrapper.querySelectorAll('[data-timeline-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var timeline = btn.closest('[data-timeline]');
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        timeline.querySelectorAll('[data-timeline-extra]').forEach(function (row) { row.hidden = expanded; });
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        btn.querySelector('[data-toggle-more]').hidden = !expanded;
        btn.querySelector('[data-toggle-less]').hidden = expanded;
      });
    });

    // ── Listeners ────────────────────────────────────────────
    panels.forEach(function (panel) {
      if (panel.classList.contains('is-unavailable')) return;
      panel.addEventListener('click', function () { select(panel.dataset.key); });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(panel.dataset.key); }
      });
    });

    ['on:variant:change', 'variant:changed', 'variantChange'].forEach(function (evtName) {
      document.addEventListener(evtName, function (e) {
        var v = (e.detail && (e.detail.variant || e.detail.currentVariant)) || e.detail;
        if (v && v.id) updatePrices(v.id);
      });
    });

    select(defaultKey);
  }

  function initAll() {
    document.querySelectorAll('.pa-so2').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
